import listActions from 'src/modules/affirmation/list/affirmationListActions';
import AffirmationService from 'src/modules/affirmation/affirmationService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'AFFIRMATION_DESTROY';

const affirmationDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: affirmationDestroyActions.DESTROY_STARTED,
      });

      await AffirmationService.destroyAll([id]);

      dispatch({
        type: affirmationDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.affirmation.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/affirmation');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: affirmationDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: affirmationDestroyActions.DESTROY_ALL_STARTED,
      });

      await AffirmationService.destroyAll(ids);

      dispatch({
        type: affirmationDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.affirmation.destroyAll.success'),
      );

      getHistory().push('/affirmation');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: affirmationDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default affirmationDestroyActions;
